import axios from "axios";
import {headers} from "@/services/headers"
import {ThunkAction} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {
    setVouchers,
    setPaginator,
    getErrors,
    loading,
    setVoucher,
    setTransactions,
    setEditMode, setShowDelete
} from "@/reducers/vouchers";
import toast from "react-hot-toast";

export const GetVouchers = (code?: string, query?: string, page = 1):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    const response = axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + code + '/vouchers?filter[search]=' + query + '&page=' + page, {
            headers: headers()
        }).then((response) => {
            dispatch(setVouchers(response.data.data));
            dispatch(setPaginator(response.data.meta));
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));
        });

    dispatch(loading(false))

    return response;
};

export const StoreVoucher = (eventId?: number, attributes?: any):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    const response = axios
        .post(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/vouchers', attributes, {
            headers: headers()
        }).then((response) => {
            dispatch(setVoucher(response.data.data));
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));
        });

    dispatch(loading(false))

    return response;
};

export const UpdateVoucher = (eventId?: number, voucherId?: number, attributes?: any):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    const response = axios
        .patch(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/vouchers/' + voucherId, attributes, {
            headers: headers()
        }).then((response) => {
            dispatch(setVoucher(response.data.data));
            dispatch(setEditMode(false));

            toast.success("Berhasil mengubah voucher");
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));
        });

    dispatch(loading(false))

    return response;
};

export const DeleteVoucher = (eventId?: number, voucherId?: number):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    const response = axios
        .delete(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/vouchers/' + voucherId, {
            headers: headers()
        }).then((response) => {
            dispatch(setVoucher(response.data.data));
            dispatch(setShowDelete(false));

            toast.success("Berhasil menghapus voucher");
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));
        });

    dispatch(loading(false))

    return response;
};

export const ShowVoucher = (eventCode?: string, voucherCode?: string):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    const response = axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/vouchers/' + voucherCode, {
            headers: headers()
        }).then((response) => {
            dispatch(setVoucher(response.data.data));
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));
        });

    dispatch(loading(false))

    return response;
};

export const GetTransactionsByVoucher = (eventCode?: string, voucherCode?:string, query?: string):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    const response = axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/vouchers/' + voucherCode + '/transactions?filter[search]=' + query, {
            headers: headers()
        }).then((response) => {
            dispatch(setTransactions(response.data.data));
            dispatch(setPaginator(response.data.meta));
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));
        });

    dispatch(loading(false))

    return response;
};
